/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGetPikJKResponseScheme } from '../../entities/schemas/GetPikJKResponseScheme';

export type TGetPikJkModel = IModel<IGetPikJkRequest, TGetPikJkResponse>;

export interface IGetPikJkRequest {}

export type TGetPikJkResponse = IGetPikJkResponse200 | IGetPikJkResponse400;

export interface IGetPikJkResponse200 extends IModelResponse<IGetPikJkResponse> {
  statusCode: 200;
}

export interface IGetPikJkResponse400 extends IModelResponse<IGetPikJkResponseError> {
  statusCode: 400;
}

export interface IGetPikJkResponse {
  data: IGetPikJKResponseScheme;
  status: EStatus;
}

export interface IGetPikJkResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetPikJkResponse | IGetPikJkResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetPikJkResponse): TResponse200;
  400(response: IGetPikJkResponseError): TResponse400;
}
